import { KalturaBaseEntry } from "kaltura-typescript-client/api/types/KalturaBaseEntry";
import { KalturaPlaylist } from "kaltura-typescript-client/api/types/KalturaPlaylist";

export function isPlaylist(
    entry: KalturaBaseEntry | KalturaPlaylist
): entry is KalturaPlaylist {
    return entry && (<KalturaPlaylist>entry).playlistContent !== undefined;
}
